var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.38,
    height: 36.208,
    viewBox: "0 0 37.38 36.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(-207.974 -2576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(219 2576)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_146",
    "data-name": "Path 146",
    transform: "translate(204.763 2592.89)",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.22612953186035 18.3184814453125 C 19.42811012268066 18.3184814453125 16.74037933349609 17.76043128967285 14.23760986328125 16.65983200073242 C 12.22602939605713 15.77523231506348 10.32433986663818 14.53871154785156 8.585350036621094 12.98462200164795 C 6.514249324798584 11.13372421264648 5.162985324859619 9.260382652282715 4.523376941680908 8.275116920471191 C 5.2220778465271 7.762428283691406 6.502225875854492 6.925048351287842 8.372159957885742 6.094662189483643 C 11.12957954406738 4.870172023773193 15.77143001556396 3.410521984100342 22.22612953186035 3.410521984100342 C 32.37971115112305 3.410521984100342 37.71331024169922 6.95766019821167 39.33095932006836 8.262248992919922 C 38.76353073120117 9.22881031036377 37.51493072509766 11.12920188903809 35.52206039428711 13.00590229034424 C 33.8790283203125 14.55316162109375 32.05569839477539 15.78426170349121 30.10269927978516 16.66500282287598 C 27.6697998046875 17.76217269897461 25.01973915100098 18.3184814453125 22.22612953186035 18.3184814453125 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.22612953186035 4.4105224609375 C 16.00322914123535 4.4105224609375 11.53203964233398 5.799612045288086 8.876968383789062 6.964912414550781 C 7.608329772949219 7.521716117858887 6.621540069580078 8.082005500793457 5.914016723632812 8.535100936889648 C 6.632694244384766 9.530667304992676 7.762294769287109 10.91641998291016 9.304347991943359 12.28588199615479 C 10.96181869506836 13.75785255432129 12.77025032043457 14.92726135253906 14.67939949035645 15.76163196563721 C 17.04314041137695 16.79468154907227 19.58222007751465 17.3184814453125 22.22612953186035 17.3184814453125 C 24.86133003234863 17.3184814453125 27.35931015014648 16.7981014251709 29.65069007873535 15.77180194854736 C 31.4965705871582 14.94503211975098 33.22335815429688 13.78637218475342 34.78311157226562 12.32798194885254 C 36.28086090087891 10.92756843566895 37.34291458129883 9.509129524230957 37.99580764770508 8.515332221984863 C 37.38462066650391 8.090851783752441 36.52577209472656 7.563534736633301 35.40798187255859 7.034121513366699 C 32.88093948364258 5.837242126464844 28.54269981384277 4.4105224609375 22.22612953186035 4.4105224609375 M 22.22612953186035 2.4105224609375 C 35.17356109619141 2.4105224609375 40.5914306640625 8.042681694030762 40.5914306640625 8.042681694030762 C 40.5914306640625 8.042681694030762 35.17356109619141 19.3184814453125 22.22612953186035 19.3184814453125 C 9.278690338134766 19.3184814453125 3.21160888671875 8.042681694030762 3.21160888671875 8.042681694030762 C 3.21160888671875 8.042681694030762 9.278690338134766 2.4105224609375 22.22612953186035 2.4105224609375 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c985c4c4f68156744c4d53fdb3480c4b.svg";
export { ForwardRef as ReactComponent };